import styled from 'styled-components';

// Inset horizontal del grid: cuánto se meten las cards desde el borde. MyCourses.styled.tsx
// consume esta misma constante para que el título de sección arranque en el mismo borde
// que las cards, en vez de duplicar el valor y arriesgar que se desincronicen.
export const GRID_INSET = '1rem';

// Grid fluido: el card compartido no tiene ancho fijo (el legacy sí, 345px).
export const ListMyCourses = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.5rem;
  width: 100%;
  padding: 1rem ${GRID_INSET};
`;
